import { executionReportsDatabase } from '../indexedDB'

export default (executionReportData) => {
    return new Promise((resolve) => {
        const compare = async () => {
            const exDb = await executionReportsDatabase.initDb()
            const executionReportList = await executionReportsDatabase.consultar(exDb.database)
            const executionReport = executionReportList.filter(r => r._id === executionReportData._id)
            if (executionReport[0]) {
                const dateExOnDB = new Date(executionReport[0].updatedAt)
                const dateCloud = new Date(executionReportData.updatedAt)
                if (dateExOnDB.getTime() > dateCloud.getTime()) {
                    resolve(false)
                } else {
                    resolve(true)
                }
            } else {
                resolve(false)
            }
        }
        compare()
    })
}
